import React from 'react';

const aboutMe = () => {
    return (
        <div id="about-me">
            <h2>About Me</h2>
            <p>
                Hello my name is Sardor Botirov. I am a Web developer. As a web developer focused on 
                customer satisfaction, I manage all aspects of web development 3⁄4 from 
                concept to requirements definition, design, development, launch, maintenance and user support. 
                I enjoy the client-facing role and working closely with team members to produce high-quality deliverable.
            </p>
        </div>
    );
}

export default aboutMe;